import { RouteProps } from 'react-router';
import user, { home } from './user';
import admin from './admin';
import errors from './errors';
import { DashboardRoute } from '../types';
import Logout from '../../views/pages/Logout';

export const root = {
  path: '/',
  redirect: home,
} as DashboardRoute;

export const logout = {
  path: '/dashboard/logout',
  component: Logout,
} as RouteProps;

export default [...errors, ...user, ...admin, logout, root] as DashboardRoute[];
